/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import axios from 'axios';

const is = require('is_js');
const parse = require('url-parse');

export interface IUploadDocMethods extends IPluginMethodMap {
  uploadDoc(args: any): Promise<any>;
}

export class UploadDocService implements IAgentPlugin {
  readonly methods: IUploadDocMethods;

  constructor() {
    this.methods = {
      uploadDoc: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    try {
      const response = await axios.post(
        `${args?.apiURL}`,
        { doc: args?.doc },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (response?.data) {
        return { url: response?.data?.data?.url };
      }
    } catch (error) {}
  }

  private getTransformConfig(data: any) {
    // const _transConfig = templateReplacer(JSON.stringify(data), {
    //   holder_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holder,
    //   holders_name: DEFAULT_APP_CONFIG?.platformSemantics?.semantics?.holders,
    //   holder_group: DEFAULT_APP_CONFIG?.platformSemantics?.HoldersGroups?.title,
    // });
    // return JSON.parse(_transConfig);
    return data;
  }
}
